// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c223a75f","839":"72778ea5"}[chunkId] + ".chunk.js";
};